import React from 'react';
import { Container } from './inner-triangle-styles';
var InnerTriangle = function () { return React.createElement(Container, null); };
export default InnerTriangle;
